// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type CreditCard40CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CreditCard40Circle: FC<CreditCard40CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="49"
        >
            <path d="M44 11.152v26c0 .8-.3 1.5-.9 2.1-.6.6-1.3.9-2.1.9H7c-.8 0-1.5-.3-2.1-.9-.6-.6-.9-1.3-.9-2.1v-26c0-.8.3-1.5.9-2.1.6-.6 1.3-.9 2.1-.9h34c.8 0 1.5.3 2.1.9.6.6.9 1.3.9 2.1Zm-37 5.45h34v-5.45H7v5.45Zm0 6.45v14.1h34v-14.1H7Z" />
        </svg>
    );
};

export default CreditCard40Circle;
